import React from 'react';

interface IBannerProps {
  text: string;
  buttonText: string;
  handlePress: () => void;
}

const Banner: React.FC<IBannerProps> = ({text, buttonText, handlePress}) => {
  return (
    <div className="absolute left-0 right-0 top-0 bg-red-500 flex justify-center items-center py-1.5">
      <p className="text-white text-lg">{text}</p>
      <button
        type="button"
        className="bg-white hover:opacity-80 transition duration-200 ml-2 -mb-0.5 rounded-full text-md font-medium text-black px-2"
        onClick={handlePress}>
        {buttonText}
      </button>
    </div>
  );
};

export default Banner;
